<template lang="html">
  <div
    :class="[ visible && 'offscreen--visible' ]"
    class="offscreen"
  >
    <div class="offscreen__header">
      <slot name="logo" />
      <div class="offscreen__actions">
        <span
          class="offscreen__action"
          @click="handleClose"
        ><CloseIcon /></span>
      </div>
    </div>
    <div class="offscreen__body">
      <slot />
    </div>
  </div>
</template>

<script>
import CloseIcon from 'beisheim/assets/images/icons/beisheim-stiftung-close.svg'

export default {
  components: {
    CloseIcon
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    $route () {
      this.handleClose()
    }
  },
  methods: {
    handleClose () {
      return this.$emit('close')
    }
  }
}
</script>

<style lang="scss">
  @import 'beisheim/scss/colors';
  @import 'beisheim/scss/scale';

  .offscreen {
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 100%;
    z-index: 10;
    width: 100%;
    height: 100vh;
    overflow: auto;
    background: gray(4);
    padding-top: scale(5);
    padding-bottom: scale(20);
    transition: transform 0.5s ease-in-out;
  }

  .offscreen--visible {
    transform: translateX(-100%);
  }

  .offscreen__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: scale(3);
  }

  .offscreen__body {
    padding: scale(3);
  }

  .offscreen__logo {
    display: block;
    width: 15rem;
  }

  .offscreen__action {
    user-select: none;
    cursor: pointer;
    svg {
      width: 12px;
    }
  }
</style>
